// removed by extract-text-webpack-plugin
module.exports = {"container":"HoldRequestInput-style__container__3VQYn","checkbox":"HoldRequestInput-style__checkbox__2CtKt","checked":"HoldRequestInput-style__checked__baGuq","icon":"HoldRequestInput-style__icon__1ssEi","label":"HoldRequestInput-style__label__ZpV_h"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/ContactDealer/HoldRequestInput-style.scss
// module id = 3054
// module chunks = 4